var React = require('react');

function RightArrowThin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.5 10.8l-2.6-2.6-.7.7 2.1 2.1H2v1h18.3l-2.1 2.1.7.7 2.6-2.6.7-.7-.7-.7z"}));
}

RightArrowThin.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = RightArrowThin;

RightArrowThin.default = RightArrowThin;
